// extracted by mini-css-extract-plugin
export default {"populationTagInputSelector":"VpwnkcPKKXkdVJUj3uEl","inputLabelDescription":"shrAcXkDqmKAiArjahRO"};